<script>
import api from '@/helpers/api'
export default {
  name: 'product.stock',
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    product: {}
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: { handler: 'onInit', immediate: true }
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.items.fetch({
        id: this.product_id
      })
      this.product = {
        ...item
      }
      this.isLoading = false
    },
    async onSave () {
      let valid = true

      if (valid) {
        const data = {
          ...this.product
        }

        try {
          this.isLoading = true
          let item = await api.items.update({
            ...data,
            id: this.product_id
          })
          this.$bvToast.toast(`Product info was saved!`, {
            title: 'Changes Saved',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
        }
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title border-bottom pb-3 mb-4">Inventory Information</h4>

      <b-form-group
        label="Unit *"
        label-for="product_unit"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <b-form-input
          id="product_unit"
          v-model.number="product.unit"
          required
          :style="{ width: '90px' }"
          class="text-center"
          :disabled="!product.is_stock_item"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Default Stock Level *"
        label-for="default_stock_level"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <g-form-number-stepper
          id="default_stock_level"
          v-model="product.default_stock_level"
          :unit="product.unit"
          :min="0"
          :disabled="!product.is_stock_item"
        />
      </b-form-group>
      <b-form-group
        label="Reorder Stock Level *"
        label-for="reorder_stock_level"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <g-form-number-stepper
          id="reorder_stock_level"
          v-model="product.reorder_stock_level"
          :unit="product.unit"
          :min="0"
          :max="product.default_stock_level"
          :disabled="!product.is_stock_item"
        />
      </b-form-group>
      <b-form-group
        label="Stock Level"
        label-for="stock_level"
        label-cols-lg="2"
        label-cols-sm="3"
      >
        <g-form-number-stepper
          id="stock_level"
          v-model="product.stock_level"
          :unit="product.unit"
          :disabled="!product.is_stock_item"
        />
      </b-form-group>
      <div class="d-flex justify-content-end border-top pt-3">
        <b-btn class="btn-label" variant="primary" v-on:click="onSave">
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </b-card>
  </g-overlay>
</template>
